function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeaderboardOptions = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _reactNative = require("react-native-web");
var Icons = _interopRequireWildcard(require("../../../Icons"));
var _Button = require("../../../Button");
var _Select = require("../../../Select");
var _View = require("../../../View");
var _Message = require("../../../Message");
var _FullScreenDialog = require("../../../FullScreenDialog");
var _SvgImage = require("../../../SvgImage");
var _reactI18next = require("react-i18next");
var _useLang = require("./useLang");
var _styles2 = require("../../../../styles");
var _utils = require("../../../../utils");
var _models = require("../../../../models");
var _reactQuery = require("react-query");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var EmailDownload = (0, _react.memo)(function (props) {
  return (0, _jsxRuntime.jsx)(_SvgImage.SvgImage, Object.assign({
    image: require("../../../../images/EmailDownload.svg")
  }, props));
});
var LeaderboardOptions = exports.LeaderboardOptions = (0, _react.memo)(function (_ref) {
  var sort = _ref.sort,
    filter = _ref.filter,
    downloadUrl = _ref.downloadUrl;
  (0, _useLang.useLang)();
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _STYLES$useStyles = _styles2.STYLES.useStyles(),
    spacing = _STYLES$useStyles.spacing;
  var _useAnalytics = (0, _utils.useAnalytics)(),
    trackEvent = _useAnalytics.trackEvent,
    trackingEvents = _useAnalytics.trackingEvents;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    _showDownloadModal = _useState2[0],
    _setShowDownloadModal = _useState2[1];
  var _useContext = (0, _react.useContext)(_utils.AuthContext),
    isAuthenticated = _useContext.isAuthenticated;
  var _hasSort = !!(sort != null && sort.items) && sort.items.length > 0;
  var _hasFilter = !!(filter != null && filter.items) && filter.items.length > 0;
  var _hasDownload = _reactNative.Platform.OS === 'web' && !!downloadUrl;
  var _hasOptions = _hasSort || _hasFilter || _hasDownload;
  var _useQuery = (0, _reactQuery.useQuery)(['data', 'user', 'email'], (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _models.User.select({
              users: ['email']
            }).find('current');
          case 2:
            return _context.abrupt("return", _context.sent.data);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })), {
      enabled: _hasDownload && isAuthenticated
    }),
    user = _useQuery.data;
  var _closeDownloadModal = function _closeDownloadModal() {
    _setShowDownloadModal(false);
  };
  var _downloadOnPress = function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _showError, _document$querySelect, token, _response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            trackEvent({
              eventName: trackingEvents.leaderboardDownload
            });
            _showError = function _showError() {
              (0, _Message.ShowMessage)({
                text: t('leaderboardOptions:download.error'),
                type: _Message.MessageType.alert,
                isCloseable: true
              });
            };
            _context2.prev = 2;
            _context2.next = 5;
            return _utils.Storage.getItem('token');
          case 5:
            _context2.t1 = _context2.sent;
            if (_context2.t1) {
              _context2.next = 8;
              break;
            }
            _context2.t1 = (_document$querySelect = document.querySelector('[name=csrf-token][content]')) == null ? void 0 : _document$querySelect.content;
          case 8:
            _context2.t0 = _context2.t1;
            if (_context2.t0) {
              _context2.next = 11;
              break;
            }
            _context2.t0 = null;
          case 11:
            token = _context2.t0;
            if (token) {
              _context2.next = 14;
              break;
            }
            throw 'no token';
          case 14:
            _context2.next = 16;
            return fetch(downloadUrl, {
              method: 'POST',
              headers: {
                accept: 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                authenticity_token: token
              })
            });
          case 16:
            _response = _context2.sent;
            if ((_response == null ? void 0 : _response.status) === 202) {
              _setShowDownloadModal(true);
            } else {
              _showError();
            }
            _context2.next = 23;
            break;
          case 20:
            _context2.prev = 20;
            _context2.t2 = _context2["catch"](2);
            _showError();
          case 23:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 20]]);
    }));
    return function _downloadOnPress() {
      return _ref3.apply(this, arguments);
    };
  }();
  if (!_hasOptions) {
    return null;
  }
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsxs)(_View.View, {
      style: styles.container,
      spacer: spacing.l,
      testID: "LeaderboardOptions",
      children: [(_hasSort || _hasFilter) && (0, _jsxRuntime.jsxs)(_View.View, {
        style: styles.options,
        spacer: spacing.l,
        children: [_hasSort && (0, _jsxRuntime.jsxs)(_View.View, {
          style: styles.dropdown,
          children: [(0, _jsxRuntime.jsx)(_reactNative.Text, {
            style: styles.dropdownSelectText,
            children: t('leaderboardOptions:sortBy')
          }), (0, _jsxRuntime.jsx)(_Select.Select, {
            items: sort.items,
            selectedId: sort.selectedId,
            onSelect: sort.onSelect,
            style: styles.dropdownSelect,
            type: _Select.SelectType.outline,
            label: t('leaderboardOptions:sortBy'),
            hideLabel: true
          })]
        }), _hasFilter && (0, _jsxRuntime.jsxs)(_View.View, {
          style: styles.dropdown,
          children: [(0, _jsxRuntime.jsx)(_reactNative.Text, {
            style: styles.dropdownSelectText,
            children: t('leaderboardOptions:filterBy')
          }), (0, _jsxRuntime.jsx)(_Select.Select, {
            items: filter.items,
            selectedId: filter.selectedId,
            onSelect: filter.onSelect,
            style: styles.dropdownSelect,
            type: _Select.SelectType.outline,
            label: t('leaderboardOptions:filterBy'),
            hideLabel: true
          })]
        })]
      }), _hasDownload && (0, _jsxRuntime.jsxs)(_View.View, {
        style: styles.download,
        children: [(0, _jsxRuntime.jsx)(_reactNative.Text, {
          style: styles.downloadLabel,
          children: t('leaderboardOptions:download.label')
        }), (0, _jsxRuntime.jsx)(_Button.Button, {
          type: _Button.ButtonType.iconOutlined,
          icon: Icons.Download,
          size: _Button.ButtonSize.large,
          iconStyle: {
            width: 25
          },
          onPress: _downloadOnPress,
          label: t('leaderboardOptions:download.ariaLabel'),
          hideLabel: true,
          testID: "LeaderboardOptionsDownload"
        })]
      })]
    }), (0, _jsxRuntime.jsx)(_FullScreenDialog.FullScreenDialog, {
      isHidden: !_showDownloadModal,
      closeCallback: _closeDownloadModal,
      title: t('leaderboardOptions:download.modal.title'),
      text: t('leaderboardOptions:download.modal.text', {
        email: user == null ? void 0 : user.email
      }),
      primaryActionLabel: t('leaderboardOptions:download.modal.buttonLabel'),
      primaryActionCallback: _closeDownloadModal,
      Image: EmailDownload,
      cardStyle: styles.downloadModalCard
    })]
  });
});